<template>
  <div class="dropdown-date-box">
    <span>每月</span>
    <el-select
      multiple
      collapse-tags
      v-model="dayList"
      style="width: 130px; margin-left: 5px; margin-right: 10px"
      @change="handleSelect"
      popper-class="test-popper"
      :disabled="limit"
    >
      <el-option v-for="item in 31" :key="item" :label="item" :value="item">
      </el-option>
    </el-select>
    <span>日</span>
    <div class="clear"></div>
  </div>
</template>

<script>
export default {
  props: {
    days: {
      type: String,
      default: "",
    },
    // 用于控制是否不可操作
    limit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    days: {
      handler(newValue, oldValue){
        if (newValue !== oldValue) {
          let arr = newValue.split(",");
          let tempArr = []
          arr.forEach(item => {
            let temp = ''
            if(item != ''){
              temp = Number(item);
              tempArr.push(temp);
            }
          })
          // 元素转为数字类型
          this.dayList = tempArr;
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      dayList: [],
    };
  },
  mounted() {
    if (!!this.days && this.days.length > 0) {
      let arr = this.days.split(",");
      // 元素转为数字类型
      this.dayList = arr.map(Number);
    } else {
      this.dayList = [];
    }
  },
  methods: {
    handleSelect(val) {
      this.$emit("changeDays", val);
    },
  },
};
</script>

<style scoped lang="scss">
.dropdown-date-box {
  width: 190px;
  display: flex;
  .clear {
    clear: both;
  }
}
</style>
<style lang="scss">
.test-popper .el-select-dropdown__list {
  display: flex;
  width: 230px;
  flex-wrap: wrap;

  .el-select-dropdown__item {
    width: 29px;
    height: 28px;
    line-height: 28px;
    padding: 0;
    text-align: center;
    margin: 3px;
    box-sizing: border-box;
  }
  .el-select-dropdown__item.selected::after {
    display: none;
  }
  .el-select-dropdown__item.selected {
    background-color: #fe4d45 !important;
    color: #fff;
    border-radius: 25px;
    font-weight: normal;
  }
}
</style>